import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiCheckCircle, FiClock, FiXCircle } from 'react-icons/fi';

const FALLBACK = 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=1920&q=80';

const STATUS_MAP = {
  abiertas: { label: 'Inscripciones abiertas', icon: <FiCheckCircle size={14} />, bg: 'bg-blue-500' },
  proximas: { label: 'Próximamente',           icon: <FiClock size={14} />,        bg: 'bg-blue-500' },
  cerradas: { label: 'Inscripciones cerradas', icon: <FiXCircle size={14} />,      bg: 'bg-gray-500' },
};

export default function TallerBanner({ taller, esGratis }) {
  const navigate = useNavigate();
  const img = taller.imagen?.url || FALLBACK;
  const status = STATUS_MAP[taller.inscripcionesEstado] || STATUS_MAP.cerradas;

  return (
    <div className="relative w-full overflow-hidden" style={{ height: 'clamp(280px, 40vw, 460px)' }}>
      {/* BG */}
      <img src={img} alt={taller.nombre} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0" style={{
        background: 'linear-gradient(to top, rgba(0,0,0,.82) 0%, rgba(0,0,0,.35) 55%, rgba(0,0,0,.10) 100%)'
      }} />

      {/* Back button */}
      <button
        onClick={() => navigate(-1)}
        className="absolute top-5 left-5 z-20 flex items-center gap-2 px-4 py-2 rounded-full bg-black/30 backdrop-blur-sm text-white text-[13px] font-semibold border border-white/20 hover:bg-black/50 transition-all"
      >
        <FiArrowLeft size={16} /> Volver
      </button>

      {/* Content */}
      <div className="absolute inset-x-0 bottom-0 z-10 flex flex-col justify-end px-5 sm:px-10 pb-10 sm:pb-14 max-w-screen-xl mx-auto">
        {/* Status + categoria */}
        <div className="flex flex-wrap items-center gap-2 mb-4">
          <span className={`inline-flex items-center gap-1.5 text-[12px] font-bold px-3 py-1.5 rounded-full text-white ${status.bg}`}>
            {status.icon} {status.label}
          </span>
          {taller.tipoActividad && (
            <span className="text-[12px] font-bold px-3 py-1.5 rounded-full bg-white/15 text-white backdrop-blur-sm border border-white/20">
              {taller.tipoActividad}
            </span>
          )}
          {esGratis && (
            <span className="text-[12px] font-bold px-3 py-1.5 rounded-full badge-gratis">
              ¡Gratis!
            </span>
          )}
        </div>

        {/* Título */}
        <h1 className="text-white font-extrabold leading-snug drop-shadow-lg mb-3"
          style={{ fontSize: 'clamp(1.75rem, 4vw, 3rem)', textShadow: '0 2px 12px rgba(0,0,0,.4)' }}>
          {taller.nombre}
        </h1>

        {/* Recinto */}
        {taller.recinto?.nombre && (
          <p className="text-white/75 text-sm font-medium flex items-center gap-1.5 leading-relaxed">
            <span>📍</span>
            <span>{taller.recinto.nombre}{taller.recinto.direccion && ` · ${taller.recinto.direccion}`}</span>
          </p>
        )}
      </div>
    </div>
  );
}
